import React, { useState, useEffect } from 'react';
import { Eye, EyeOff, AlertCircle } from 'lucide-react';
import { api } from '../services/api';

const LoginPage = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Acorda o backend assim que o usuário entra na tela de login
  useEffect(() => {
    const wakeUpBackend = async () => {
      try {
        // Isso remove o "Cold Start" do Vercel enquanto o usuário digita
        await api.get('/health'); 
      } catch (err) {
        console.log("Servidor acordando...");
      }
    };
    wakeUpBackend();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const result = await api.login(email, password);
      onLogin(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#05050A] flex">
      {/* Lado Esquerdo - Hero Image */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#05050A] via-transparent to-transparent z-10" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#05050A] via-transparent to-transparent z-10" />
        <img
          src="https://customer-assets.emergentagent.com/job_filmlibrary-3/artifacts/6cmo3mr5_Capa.png"
          alt="Pack Cinematográfico Premium"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute bottom-12 left-12 z-20">
          <p className="text-white/60 text-sm mb-2">Biblioteca Exclusiva</p>
          <h2 className="text-white text-3xl font-bold font-['Manrope']">+100 Cenas</h2>
          <p className="text-white/80 mt-2">Qualidade cinematográfica 4K</p>
        </div>
      </div>

      {/* Lado Direito - Formulário */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="bg-[#0A0A12]/80 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl shadow-black/50">
            <div className="flex flex-col items-center mb-8">
              <h1 className="text-white text-xl font-bold tracking-tight font-['Manrope'] text-center">
                Pack Cinematográfico
              </h1>
              <span className="text-[#0056D2] text-2xl font-bold font-['Manrope']">Premium</span>
              <p className="text-slate-400 text-sm mt-2">Acesse sua biblioteca exclusiva</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-slate-300 text-sm font-medium mb-2">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  required
                  className="w-full bg-[#12121A] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder-slate-600 focus:outline-none focus:border-[#0056D2]/50 focus:ring-2 focus:ring-[#0056D2]/20 transition-all duration-300"
                />
              </div>

              <div>
                <label className="block text-slate-300 text-sm font-medium mb-2">Senha</label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                    className="w-full bg-[#12121A] border border-white/10 rounded-xl px-4 py-3.5 pr-12 text-white placeholder-slate-600 focus:outline-none focus:border-[#0056D2]/50 focus:ring-2 focus:ring-[#0056D2]/20 transition-all duration-300"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300 transition-colors"
                  >
                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>

              {error && (
                <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/20 rounded-xl text-red-400 text-sm">
                  <AlertCircle className="w-5 h-5 flex-shrink-0" />
                  <span>{error}</span>
                </div>
              )}

              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-[#0056D2] hover:bg-[#0066FF] text-white font-semibold py-3.5 rounded-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-lg shadow-[#0056D2]/25"
              >
                {isLoading ? (
                  <>
                    <div className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full" />
                    <span>Entrando...</span>
                  </>
                ) : (
                  'Entrar'
                )}
              </button>
            </form>
          </div>
          <p className="text-center text-slate-700 text-xs mt-6">
            © 2026 Pack Cinematográfico Premium
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
